import { defaultField, defaultPercentField, isContainedInList, subStringPercentFormat } from "helpers/row-logic-helper";
import { get, findIndex } from "lodash";
import { LOAN_RATE_TYPES, DEAL_PROJECT_TYPES, DEAL_STATUSES } from "@loanbossinc/component-library";

export const isAdmin = data => false;

export const shouldShowFixedIndex = data => isContainedInList(data, "loanProceedAssumptions[0].rateTypeId", [
  LOAN_RATE_TYPES.FIXED
]);

export const shouldShowIoPeriods = data => isContainedInList(data, "loanProceedAssumptions[0].amortizationTypeId", [
  "5ea9e68d-4680-11e9-82f6-0242ac120002", "65a393e5-4680-11e9-82f6-0242ac120002"
]);

export const shouldShowFloatingIndex = data => isContainedInList(data, "loanProceedAssumptions[0].rateTypeId", [
  LOAN_RATE_TYPES.FLOATING
]);

export const shouldShowEstDevelopmentCost = data => isContainedInList(data, "projectTypeId", [
  DEAL_PROJECT_TYPES.CONSTRUCTION
]);

export const shouldShowPricingGuidance = data => isContainedInList(data, "projectTypeId", [
  DEAL_PROJECT_TYPES.STABILIZED,
  DEAL_PROJECT_TYPES.VALUE_ADD
]);
export const groupsMapNestedRows = deal => {
  const funds = defaultField(deal, "funds");
  if (!funds) {
    return [];
  }

  return funds.reduce((accum, fund) => {
    if (!fund) {
      return accum;
    }

    const allocationPercent = defaultPercentField(fund, "fundDealBridge.allocationPercent", 1);
    const isPrimary = get(fund, "fundDealBridge.isPrimary");

    accum.push({
      name: defaultField(fund, "name"),
      allocationPercent: allocationPercent ? `${allocationPercent}% allocated` : undefined,
      isPrimary: isPrimary ? "Primary" : undefined
    });

    return accum;
  }, []);
};

export const collabGroupsMapNestedRows = deal => {
  const collaborationGroups = defaultField(deal, "collaborationGroups");
  if (!collaborationGroups) {
    return [];
  }

  return collaborationGroups.reduce((accum, collaborationGroup) => {
    if (!collaborationGroup) {
      return accum;
    }

    accum.push({
      name: defaultField(collaborationGroup, "name")
    });

    return accum;
  }, []);
};

export const setLoanAssumptionDefaults = (value, formik) => {
  const { values, setFieldValue } = formik;
  const loanProceedAssumptions = values.ancillary.loanProceedAssumptions;
  const index = findIndex(loanProceedAssumptions, o => o.loanType == value);
  const selectedAssumption = loanProceedAssumptions[index];
  setFieldValue("loanProceedAssumptions[0].term", selectedAssumption.term);
  setFieldValue("loanProceedAssumptions[0].amortization", selectedAssumption.amortization);
  setFieldValue("loanProceedAssumptions[0].loanSpread", selectedAssumption.loanSpread);
  setFieldValue("loanProceedAssumptions[0].rateTypeId", selectedAssumption.rateTypeId);
  setFieldValue("loanProceedAssumptions[0].indexId", selectedAssumption.indexId);
  setFieldValue("loanProceedAssumptions[0].minDSCR", selectedAssumption.minDSCR);
  setFieldValue("loanProceedAssumptions[0].maxLTV", selectedAssumption.maxLTV);
  setFieldValue("loanProceedAssumptions[0].minDebtYield", selectedAssumption.minDebtYield);
  setFieldValue("loanProceedAssumptions[0].UwRate", selectedAssumption.UwRate);

  setFieldValue("loanProceedAssumptions[0].amortizationTypeId", selectedAssumption.amortizationTypeId);
  setFieldValue("loanProceedAssumptions[0].amortizationTerm", selectedAssumption.amortizationTerm);
  setFieldValue("loanProceedAssumptions[0].amortizationRate", selectedAssumption.amortizationRate);
  setFieldValue("loanProceedAssumptions[0].interestOnlyPeriods", selectedAssumption.interestOnlyPeriods);
  setFieldValue("loanProceedAssumptions[0].closingCosts", selectedAssumption.closingCosts);
  setFieldValue("loanProceedAssumptions[0].dayCountId", selectedAssumption.dayCountId);
};

export const hasBrokerAccess = data => data.authentication.companyTypes.map(ct => ct.name).includes("Broker");

export const isClosedDeal = data => data.dealStatusId === DEAL_STATUSES.CLOSED;

export const shouldSeeReadyForLenderIntegration = data => data.authentication.isSystemAdmin;
